/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  Address,
  AddressFromJSON,
  AddressToJSON,
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  EnrollmentPaymentDetails,
  EnrollmentPaymentDetailsFromJSON,
  EnrollmentPaymentDetailsToJSON,
  LicensingPaymentDetails,
  LicensingPaymentDetailsFromJSON,
  LicensingPaymentDetailsToJSON,
  PaymentMethodKey,
  PaymentStatusKey,
} from './'

/**
 *
 * @export
 * @interface Payment
 */
export interface Payment {
  /**
   *
   * @type number
   * @memberof Payment
   */
  paymentKey: number
  /**
   *
   * @type Date
   * @memberof Payment
   */
  begunAt: Date
  /**
   *
   * @type number
   * @memberof Payment
   */
  userKey: number
  /**
   *
   * @type PaymentMethodKey
   * @memberof Payment
   */
  paymentMethodKey: PaymentMethodKey
  /**
   *
   * @type CashAmount
   * @memberof Payment
   */
  amount: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof Payment
   */
  tax: CashAmount
  /**
   *
   * @type string
   * @memberof Payment
   */
  taxTransactionId?: string
  /**
   *
   * @type CashAmount
   * @memberof Payment
   */
  total?: CashAmount
  /**
   *
   * @type string
   * @memberof Payment
   */
  orderId?: string
  /**
   *
   * @type PaymentStatusKey
   * @memberof Payment
   */
  paymentStatusKey: PaymentStatusKey
  /**
   *
   * @type Address
   * @memberof Payment
   */
  address?: Address
  /**
   *
   * @type string
   * @memberof Payment
   */
  desc?: string
  /**
   *
   * @type LicensingPaymentDetails
   * @memberof Payment
   */
  licensingPayment?: LicensingPaymentDetails
  /**
   *
   * @type {Array<LicensingPaymentDetails>}
   * @memberof Payment
   */
  licensingPayments?: Array<LicensingPaymentDetails>
  /**
   *
   * @type {Array<EnrollmentPaymentDetails>}
   * @memberof Payment
   */
  enrollmentPayments?: Array<EnrollmentPaymentDetails>
}

export function PaymentFromJSON(json: any): Payment {
  return PaymentFromJSONTyped(json, false)
}

export function PaymentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Payment {
  if (json === undefined || json === null) {
    return json
  }
  return {
    paymentKey: json['paymentKey'],
    begunAt: new Date(json['begunAt']),
    userKey: json['userKey'],
    paymentMethodKey: json['paymentMethodKey'],
    amount: CashAmountFromJSON(json['amount']),
    tax: CashAmountFromJSON(json['tax']),
    taxTransactionId: !exists(json, 'taxTransactionId')
      ? undefined
      : json['taxTransactionId'],
    total: !exists(json, 'total')
      ? undefined
      : CashAmountFromJSON(json['total']),
    orderId: !exists(json, 'orderId') ? undefined : json['orderId'],
    paymentStatusKey: json['paymentStatusKey'],
    address: !exists(json, 'address')
      ? undefined
      : AddressFromJSON(json['address']),
    desc: !exists(json, 'desc') ? undefined : json['desc'],
    licensingPayment: !exists(json, 'licensingPayment')
      ? undefined
      : LicensingPaymentDetailsFromJSON(json['licensingPayment']),
    licensingPayments: !exists(json, 'licensingPayments')
      ? undefined
      : (json['licensingPayments'] as Array<any>).map(
          LicensingPaymentDetailsFromJSON
        ),
    enrollmentPayments: !exists(json, 'enrollmentPayments')
      ? undefined
      : (json['enrollmentPayments'] as Array<any>).map(
          EnrollmentPaymentDetailsFromJSON
        ),
  }
}

export function PaymentToJSON(value?: Payment | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    paymentKey: value.paymentKey,
    begunAt: value.begunAt.toISOString().substr(0, 10),
    userKey: value.userKey,
    paymentMethodKey: value.paymentMethodKey,
    amount: CashAmountToJSON(value.amount),
    tax: CashAmountToJSON(value.tax),
    taxTransactionId: value.taxTransactionId,
    total: CashAmountToJSON(value.total),
    orderId: value.orderId,
    paymentStatusKey: value.paymentStatusKey,
    address: AddressToJSON(value.address),
    desc: value.desc,
    licensingPayment: LicensingPaymentDetailsToJSON(value.licensingPayment),
    licensingPayments:
      value.licensingPayments === undefined
        ? undefined
        : (value.licensingPayments as Array<any>).map(
            LicensingPaymentDetailsToJSON
          ),
    enrollmentPayments:
      value.enrollmentPayments === undefined
        ? undefined
        : (value.enrollmentPayments as Array<any>).map(
            EnrollmentPaymentDetailsToJSON
          ),
  }
}
